import { ColumnFilter } from "Components/AppGrid/shipeezi-new-grid";
import { Searches } from "Models/shipeezi.table";

import { SearchAttribute } from "../models/search.attribute";

export const onSearch = (searches: ColumnFilter[]) => {
  const attributes: SearchAttribute[] = [];

  if (searches) {
    for (const search of searches) {
      if (!search.name || !search.value) continue;
      attributes.push({
        attribute: search.name,
        values: [search.value],
      });
    }
  }

  return attributes;
};

export const mountSearchToBackend = (keys: string[], value: string): Searches | undefined => {
  if (!value || !value.trim()) return undefined;

  const mount: { [key: string]: string } = {};

  keys.forEach((key) => {
    mount[key] = value as any;
  });

  return [mount];
};

export const mountSearchByOrToBackend = (keys: string[], value: string): Searches | undefined => {
  if (!value || !value.trim()) return undefined;

  const mount: { [key: string]: string }[] = [];

  keys.forEach((key) => {
    mount.push({
      [key]: value,
    });
  });

  return mount;
};
